var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.75C3.58579 22.75 3.25 22.4142 3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H11.2857C12.5284 21.25 13.5357 20.2426 13.5357 19V8.30556H8.57143C8.26616 8.30556 7.99135 8.12053 7.87651 7.83768C7.76168 7.55483 7.82974 7.23061 8.04862 7.01781L13.7629 1.46225C14.054 1.17925 14.5174 1.17925 14.8085 1.46225L20.5228 7.01781C20.7417 7.23061 20.8097 7.55483 20.6949 7.83768C20.5801 8.12053 20.3053 8.30556 20 8.30556H15.0357V19C15.0357 21.0711 13.3568 22.75 11.2857 22.75H4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerRightUp);
export default __webpack_public_path__ + "static/media/corner-right-up.945a578d4349c704c9118f28e9743718.svg";
export { ForwardRef as ReactComponent };